import { render, staticRenderFns } from "./journeyyList.vue?vue&type=template&id=38c8a3ea&scoped=true&"
import script from "./journeyyList.vue?vue&type=script&lang=js&"
export * from "./journeyyList.vue?vue&type=script&lang=js&"
import style0 from "./journeyyList.vue?vue&type=style&index=0&id=38c8a3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8a3ea",
  null
  
)

export default component.exports